import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import { ReactHookForm } from "../../../../components/hook-form/react-hook-form.component";
import { useReactHookForm } from "../../../../hooks/useReactHookForm";
import { AddNewPriceFields } from "./add-new-price-form.component";
import { FormGridEditable } from "../../../../components/hook-form/form-grid-editable.component";
import { servicesEditableColumns } from "../../../services/grid-editable-columns";
import { GridColumnConfig, GridPreference } from "../../../../models/gridCoumnConfig";
import { useAuthorize } from "../../../../hooks/use-authorize";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { servicesApiKeyStore } from "../../../../api/masters/services-api-key-store";
import { useSaveData } from "../../../../hooks/useSaveData";
import ProjectServiceNotReadyFields from "../../project-forms/project-service-not-ready-fields.component";
import React, { useEffect, useRef, useState } from "react";
import { projectsApiKeyStore } from "../../../../api/projects-api-key-store";
import ReportIcon from '@mui/icons-material/Report';
import { useSnackbar } from "../../../../hooks/use-snackbar.hook";
import { Service } from "../../../../models/masters/service";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { gridApiKeyStore } from "../../../../api/grid-api-key-store";
import { State } from "@progress/kendo-data-query";
import useDebounce from "../../../../hooks/use-debounce";


const styling = {
    dialogTitleStyle: { padding: '16px 24px 0' },
    contentPadding: { paddingTop: '30px' },
    buttonPadding: { paddingTop: '20px' },
    tabHeading: { fontWeight: 'bold' },
    buttonStyle: { width: '130px' },
};

const servicePriceValidationSchema1 = Yup.object().shape({
    pricingListName: Yup.string().required('Pricing list name is required'),
    pricingStartDate: Yup.string().required('Pricing start date is required'),
});

const servicePriceValidationSchema2 = Yup.object().shape({
    pricingListName: Yup.string().required('Pricing list name is required'),
    pricingStartDate: Yup.string().required('Pricing start date is required'),
    priceListToEnd: Yup.object()
        .shape({
            pricingListID: Yup.string()
                .nullable()
                .required('Select Price List To End is required')
                .test('not-zero', 'Select Price List To End is required', (value) => value !== '' && value !== '0'),
        })
        .required('Select Price List To End is required'),
});

interface CellProps {
    servicePricingData: any;
}

interface CustomGridCellProps {
    field: string;
}

interface AddNewPriceDialog {
    openDialog: boolean;
    title: string;
    isEdit: boolean;
    projectID: any;
    pricingID: any;
    projectType: any
    onSavePricing: () => void;
    onClosedDialog: () => void;
}

export const AddNewPriceDialog = ({
    openDialog,
    title,
    isEdit,
    projectID,
    pricingID,
    projectType,
    onSavePricing,
    onClosedDialog
}: AddNewPriceDialog) => {



    const isDisableEditableColumn = useAuthorize([UserPermissionName.EDIT_SREVICE_PRICE_PROJECT]);

    const customColumns: GridColumnConfig[] = [
        {
            title: 'Invoice Amount ($)', // Main heading
            field: '', // Leave empty as it is a group header
            filter: 'text',
            isHideColumnMenu: true,
            children: [
                {
                    title: 'Service',
                    field: 'price',
                    filter: 'text',
                    fieldType: 'currency',
                    editable: true,
                    editor: 'numeric',
                    isDecimal: true,
                    isDisable: !isDisableEditableColumn,
                    width: '110'
                },
                {
                    title: 'Retest',
                    field: 'invoiceRetestAmount',
                    filter: 'text',
                    fieldType: 'currency',
                    editable: true,
                    editor: 'numeric',
                    isDecimal: true,
                    isDisable: !isDisableEditableColumn,
                    width: '110'
                },
            ],
        },
        {
            title: 'Accrual Amount ($)', // Main heading for accrual
            field: '', // Leave empty as it is a group header
            filter: 'text',
            isHideColumnMenu: true,
            children: [
                {
                    title: 'Service',
                    field: 'accrualAmount',
                    filter: 'text',
                    fieldType: 'currency',
                    editable: true,
                    editor: 'numeric',
                    isDecimal: true,
                    isDisable: !isDisableEditableColumn,
                    width: '110'
                },
                {
                    title: 'Retest',
                    field: 'accrualRetestAmount',
                    filter: 'text',
                    fieldType: 'currency',
                    editable: true,
                    editor: 'numeric',
                    isDecimal: true,
                    isDisable: !isDisableEditableColumn,
                    width: '110'
                },
            ],
        },
        {
            title: 'Match Billing',
            field: 'matchbilling',
            filter: 'text',
            width: '150',
            searchable: false,
            isGroupable: false,
            isHideColumnMenu: true
        },
        {
            title: 'Percentage',
            field: 'percentage',
            filter: 'text',
            fieldType: 'currency',
            editable: true,
            editor: 'numeric',
            isDecimal: true,
            isDisableByTime: true,
            searchable: false,
            isGroupable: false,
            isHideColumnMenu: true,
            width: '150',
        },
        {
            title: 'Warning',
            field: 'warningText',
            filter: 'text',
            hide: !isEdit,
            searchable: false,
            isGroupable: false,
            isHideColumnMenu: true,
            width: '150',
        },
    ];

    const [enableValidation, setEnableValidation] = useState<boolean>(false);



    const [services, setServices] = useState<any[]>([]);
    const [originalServiceData, setOriginalService] = useState<any[]>([]);

    const [checkedService, setCheckedService] = useState<any>();
    const [checkedServiceDialog, setCheckedServiceDialog] = useState<boolean>(false);

    const form = useReactHookForm({
        defaultValues: {
            pricingListName: "",
            pricingStartDate: '',
            pricingEndDate: '',
            pricingListAppliesToLotType: '',
            dryRunFee: "",
            lateCancellationFee: "",
            tripCharge: "",
            endPriorPricingList: "Yes",
            priceListToEnd: null
        },
        yupSchema: isEdit ? servicePriceValidationSchema1 : enableValidation ? servicePriceValidationSchema2 : servicePriceValidationSchema1
    });


    const { data, isLoading, isFetching } = useLoadData<ApiResponse<any[]>>(
        servicesApiKeyStore.getProjectServices(!isEdit ? projectID : 0)
    );

    const { data: pricingListData, isLoading: isPricingLoading, isFetching: isPricingFetching } = useLoadData<ApiResponse<any>>(
        projectsApiKeyStore.getProjectPricingDetailsByProjectID(projectID, isEdit ? pricingID : 0)
    );

    const getServicePriceByName = (serviceData: any, serviceName: any) => {
        const service = serviceData?.find(
            (item: any) => item.serviceName === serviceName
        );
        return service ? service.price : null;
    };

    useEffect(() => {
        if (data) {
            const filtered = data?.data?.filter(
                service => !service.isNotReadyService
            );
            setServices(filtered);
            setOriginalService(data?.data);
        }
    }, [data]);

    useEffect(() => {
        if (pricingListData) {
            form.reset({
                pricingListName: pricingListData?.data?.pricingListName ?? "",
                pricingStartDate: pricingListData?.data?.pricingStartDate ?? '',
                pricingEndDate: pricingListData?.data?.pricingEndDate ?? '',
                projects: pricingListData?.data?.pricingListMappedProjects ?? [],
                pricingListAppliesToLotType: pricingListData?.data?.pricingListAppliesToLotType ?? '',
                endPriorPricingList: pricingListData?.data?.endPriorPricingList ?? 'Yes',
                priceListToEnd: null,
                dryRunFee: getServicePriceByName(pricingListData?.data?.services, "Dry Run"),
                lateCancellationFee: getServicePriceByName(pricingListData?.data?.services, "Late Cancellation"),
                tripCharge: getServicePriceByName(pricingListData?.data?.services, "Trip Charge"),
            });

            const filteredServices = pricingListData?.data?.services?.filter(
                (service: any) => !service.isNotReadyService
            );
            setServices(filteredServices);
            setOriginalService(pricingListData?.data?.services);
        }
    }, [pricingListData])

    const { isLoading: isNewPriceLoading, isError, error, mutateAsync } = useSaveData(
        isEdit ? projectsApiKeyStore.updatePriceList() : projectsApiKeyStore.createPriceList());

    const handleSubmit = async (filtersData: any) => {

        const notReadyServices =
            originalServiceData
                ?.filter((s: any) => s.isNotReadyService)
                .map((s: any) => ({
                    serviceID: s.serviceID,
                    price:
                        s.serviceName === 'Dry Run'
                            ? filtersData?.dryRunFee
                            : s.serviceName === 'Late Cancellation'
                                ? filtersData?.lateCancellationFee
                                : s.serviceName === 'Trip Charge'
                                    ? filtersData?.tripCharge
                                    : s.price,
                    accrualAmount: s.accrualAmount,
                    invoiceRetestAmount: s.invoiceRetestAmount,
                    accrualRetestAmount: s.accrualRetestAmount,
                })) || [];

        const pricingServices =
            filtersData?.pricingServices?.map((s: any) => ({
                serviceID: s.serviceID,
                price: s.price,
                accrualAmount: s.accrualAmount,
                invoiceRetestAmount: s.invoiceRetestAmount,
                accrualRetestAmount: s.accrualRetestAmount,
            })) || [];

        const payload = {
            projectID,
            ...(isEdit && {
                pricingListID: pricingID,
            }),
            pricingListName: filtersData?.pricingListName || null,
            pricingStartDate: filtersData?.pricingStartDate || null,
            pricingEndDate: filtersData?.pricingEndDate || null,
            pricingListAppliesToLotType: filtersData?.pricingListAppliesToLotType || null,
            services: [...pricingServices, ...notReadyServices],

            // 👇 These properties exist ONLY when isEdit is false
            ...(!isEdit && {
                endPriorPricingList:
                    filtersData?.endPriorPricingList === "Yes"
                        ? true
                        : filtersData?.endPriorPricingList === "No"
                            ? false
                            : null,
                priceListToEnd: filtersData?.priceListToEnd?.pricingListID || null,
            }),
        };
        await mutateAsync({ data: payload });
        onSavePricing();
        onClosedDialog();
    };




    const WarningCell = ({ servicePricingData }: CellProps) => {
        const showWarning = servicePricingData?.pricingListServiceMappingID;

        return (
            <td>
                {!showWarning && (
                    <Tooltip title={<Typography variant="body1">This service is not yet included in the Pricing List and will be added when you save.</Typography>}>
                        <ReportIcon className="btnEdit" style={{ color: '#FE9A37' }} sx={{ fontSize: 30 }} />
                    </Tooltip>
                )}
            </td>
        );
    };

    const handleCheckboxClicked = (checkedValue: boolean, service: any) => {
        setCheckedService(checkedValue ? service : undefined);
        setCheckedServiceDialog(checkedValue);
    }

    const MatchBillingCell = React.memo(({ servicePricingData }: CellProps) => {
        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            handleCheckboxClicked(event?.target?.checked, servicePricingData?.dataItem)
        };

        return (
            <td>
                {(servicePricingData?.dataItem?.invoiceRetestAmount) && (
                    <Checkbox
                        checked={servicePricingData?.dataItem?.invoiceRetestAmount == servicePricingData?.dataItem?.accrualRetestAmount}
                        onChange={handleChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                )}
            </td>
        );
    });

    const CustomGridCell = ({ field }: CustomGridCellProps) => {
        if (field === 'warningText' && isEdit) {
            return (dataItem: any) => {
                return <WarningCell servicePricingData={dataItem.dataItem} />;
            };
        }
        if (field === 'matchbilling') {
            return (dataItem: any) => {
                return <MatchBillingCell servicePricingData={dataItem} />;
            };
        }
    };

    const handleSubmitClick = () => {
        form.handleSubmit(handleSubmit)();
    };

    const handleEnableValidation = (value: boolean) => {
        setEnableValidation(value);
    }

    const inputRefs = useRef<Record<string, HTMLInputElement | null>>({});
    const internalValueRefs = useRef<Record<string, string>>({});
    const selectRefs = useRef<Record<string, string | null>>({});
    const { showSnackbar } = useSnackbar();

    const formatToTwoDecimals = (value: any) => {
        // Convert to number in case it's a string
        const num = Number(value);

        // Check if it's an integer (no decimals)
        if (Number.isInteger(num)) {
            return num.toFixed(2); // Add ".00"
        }

        return value.toString(); // Already has decimals, return as-is
    };

    const CustomGroupHeaderCell = (props: any) => {
        const [hovered, setHovered] = useState(false);
        const handleMouseOver = () => {
            setHovered(true);
        };
        const handleMouseOut = () => {
            setHovered(false);
        };

        const buttonStyle = {
            color: 'white',
            backgroundColor: '#0000b5',
            padding: '8px',
            maxHeight: '28px',
            marginTop: '6px',
        };
        const groupKey = props?.dataItem?.value;
        const [inputValues, setInputValues] = useState<Record<string, string>>({});

        const [selectedModes, setSelectedModes] = useState<Record<string, '' | 'Equal' | 'Percentage'>>({});
        const inputValue = inputValues[groupKey] ?? internalValueRefs.current[groupKey] ?? '';

        const selectedMode = selectedModes[groupKey] ?? selectRefs.current[groupKey] ?? '';

        const totalAccrualAmount = props?.dataItem?.items?.reduce((total: any, service: any) => {
            const amount = parseFloat(service.accrualAmount);
            return total + (isNaN(amount) ? 0 : amount);
        }, 0);

        const totalPriceAmount = props?.dataItem?.items?.reduce((total: any, service: any) => {
            const amount = parseFloat(service.price);
            return total + (isNaN(amount) ? 0 : amount);
        }, 0);

        const calculateAmountPerService = (amount: number, service: Service, mode: string, count: number): number =>
            isNaN(amount) || count <= 0
                ? 0
                : mode === 'Equal'
                    ? amount / count
                    : mode === 'Percentage'
                        ? (amount * service?.percentage) / 100
                        : 0;

        const handleClick = () => {
            const amount = parseFloat(inputRefs.current[groupKey]?.value ?? '');
            if (isNaN(amount)) {
                showSnackbar('Enter a Contract Value', 'error');
                return;
            }

            if (!selectedMode) {
                showSnackbar('Please Select Distribution Type', 'error');
                return;
            }

            const selectedServices = props?.dataItem?.items?.filter((data: any) => !!data?.isSelected);

            if (!selectedServices?.length) {
                showSnackbar('No selected services in this group.', 'error');
                return;
            }

            if (selectedMode === 'Percentage') {
                let totalPercentage = 0;
                for (const service of selectedServices) {
                    const percentage = Number(service?.percentage);
                    if (isNaN(percentage) || percentage <= 0) {
                        showSnackbar('All selected services must have a valid percentage entered.', 'error');
                        return;
                    }
                    totalPercentage += percentage;
                }

                if (totalPercentage > 100) {
                    showSnackbar('Total percentage cannot exceed 100%.', 'error');
                    return;
                }
            }

            const updatedSelectedServices = selectedServices.map((service: Service) => ({
                ...service,
                accrualAmount: (calculateAmountPerService(amount, service, selectedMode, selectedServices?.length))?.toString(),
                accrualRetestAmount: (calculateAmountPerService(amount, service, selectedMode, selectedServices?.length))?.toString(),
            }));

            const updatedFiltered = services?.map((originalService: any) => {
                let updatedService = {
                    ...originalService,
                    isSelected: false,
                };

                const match = updatedSelectedServices.find((s: any) => s?.serviceID === originalService?.serviceID);
                if (match) {
                    updatedService = match;
                }

                return updatedService;
            });

            internalValueRefs.current[groupKey] = "";
            setInputValues((prev) => ({
                ...prev,
                [groupKey]: "",
            }));

            selectRefs.current[groupKey] = "";
            setSelectedModes((prev) => ({
                ...prev,
                [groupKey]: "",
            }));

            const updatedService = updatedFiltered?.map((service: any) => {
                const matched = props?.dataItem?.items?.find((item: any) => item?.serviceID === service?.serviceID);

                if (matched) {
                    const { percentage, ...rest } = service;
                    return { ...rest, isSelected: false };
                }

                return service;
            });

            // setValue(name, updatedService)
            setServices(updatedService);
        };

        const handleContractValueInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;

            internalValueRefs.current[groupKey] = value;

            setInputValues((prev) => ({
                ...prev,
                [groupKey]: value,
            }));
        };

        const handleSelectInputChange = (e: any) => {
            selectRefs.current[groupKey] = e.target.value;

            const updatedData: any = services?.map(service => {
                const matched = props?.dataItem?.items?.find((item: any) => item?.serviceID === service?.serviceID);

                if (e.target.value === 'Percentage') {
                    // If matched, add percentage
                    if (matched) {
                        return { ...service, percentage: "" };
                    } else {
                        return service;
                    }
                } else {
                    // In all cases, remove percentage if it exists
                    const { percentage, ...rest } = service;
                    return rest;
                }
            });
            setServices(updatedData);

            setSelectedModes((prev) => ({
                ...prev,
                [groupKey]: e.target.value as 'Equal' | 'Percentage',
            }));
        };
        const invoiceAmountElement: any = document?.querySelector('.invoice-amount-class');
        const invoiceAmountLeft = invoiceAmountElement?.getBoundingClientRect()?.left;

        const accrualAmountelement: any = document?.querySelector('.accrual-amount-class');
        const accrualAmountLeft = accrualAmountelement?.getBoundingClientRect()?.left;


        if (props?.dataItem?.field === 'serviceGroupName') {
            return (
                props.tdProps && (
                    <td
                        {...props.tdProps}
                        style={{
                            backgroundColor: props.color,
                            position: 'relative'
                        }}
                    >
                        {props.children && (
                            <>
                                <p className="k-reset">
                                    {props.children.props.children[0]}
                                    {props.dataItem[props.field]}
                                    <div style={{ display: 'flex', minWidth: 455, gap: 6, paddingLeft: 10 }}>
                                        <FormControl size="small" style={{ width: 170 }}>
                                            <TextField
                                                type="number"
                                                value={inputValue}
                                                inputRef={(el) => {
                                                    if (el) inputRefs.current[groupKey] = el;
                                                }}
                                                onChange={handleContractValueInputChange}
                                                style={{ width: 170 }}
                                                size="small"
                                                label="Contract Value"
                                            />
                                        </FormControl>
                                        <FormControl size="small">
                                            <InputLabel id={`distributionType-select-label`}>Distribution Type</InputLabel>
                                            <Select
                                                value={selectedMode}
                                                onChange={handleSelectInputChange}
                                                variant="outlined"
                                                size="small"
                                                placeholder="Select"
                                                style={{ width: 190 }}
                                                label="Distribution Type"
                                            >
                                                <MenuItem value="Equal">Equal</MenuItem>
                                                <MenuItem value="Percentage">Percentage</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <Button
                                            className="btn  btn-primary btn-sm sitDefaultBtn"
                                            style={buttonStyle}
                                            // onMouseOver={handleMouseOver}
                                            // onMouseOut={handleMouseOut}
                                            onClick={handleClick}
                                        >
                                            Apply
                                        </Button>
                                    </div>
                                </p>
                                <div style={{ position: 'absolute', left: `900px`, top: '16px', pointerEvents: 'none' }}>
                                    <Typography variant='body1'><b style={{ paddingLeft: 5 }}>${formatToTwoDecimals(totalPriceAmount?.toFixed(2))}</b></Typography>
                                </div>
                                <div style={{ position: 'absolute', left: `1120px`, top: '16px' }}>
                                    <Typography variant='body1'><b style={{ paddingLeft: 5 }}>${formatToTwoDecimals(totalAccrualAmount?.toFixed(2))}</b></Typography>
                                </div>
                            </>
                        )}
                    </td>
                )
            );
        }

        return (
            props.tdProps && (
                <td
                    {...props.tdProps}
                    style={{
                        backgroundColor: props.color,
                    }}
                >
                    {props.children && (
                        <p className="k-reset">
                            {props.children.props.children[0]}
                            {props.dataItem[props.field]}
                        </p>
                    )}
                </td>
            )
        );
    };

    const handleClosedCheckoxDialog = () => {
        setCheckedService(undefined);
        setCheckedServiceDialog(false);
    }

    const handleSumbitConfirm = () => {
        const updatedServices = form.getValues('pricingServices')?.map((service: any) => {
            if (service.serviceID === checkedService?.serviceID) {
                return {
                    ...service,
                    accrualRetestAmount: service.invoiceRetestAmount || ""
                };
            }
            return service;
        });
        // handleServiceWithPercentage(updatedServices);
        setServices(updatedServices);
        handleClosedCheckoxDialog();
    }

    // -------------------------------------------------Grid Layout------------------------------

    const {
        isLoading: isLoadingGridLayout,
        data: gridLayouts,
        refetch: refetchGridLayout,
    } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Project Pricing Service', 'Project Pricing Service'));


    const { mutateAsync: mutateGridLayoutAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
    const [gridConfig, setGridConfig] = useState<{
        dataState: State | undefined;
        columns: any[] | undefined;
    }>();

    const [filteredPlanLibraries, setFilteredPlanLibraries] = useState<any[]>([]);

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 300);

    useEffect(() => {
        const filteredProjectPricingList = services?.filter((projectPricing) =>
            Object.values(projectPricing).some(
                (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
            )
        );
        setFilteredPlanLibraries(filteredProjectPricingList || []);
    }, [debouncedSearchTerm, services]);

    const handleInputChange = (value: string) => {
        setSearchTerm(value);
    };

    const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
        const data = {
            filterJSON: JSON.stringify(gridDataState),
            columnJSON: JSON.stringify(gridColumns),
            gridName: 'Project Pricing Service',
            pageName: 'Project Pricing Service',
        };

        mutateGridLayoutAsync({ data }).then(() => {
            refetchGridLayout();
        });
    };

    const handleResetLayout = () => {
        const data = {
            filterJSON: null,
            columnJSON: null,
            gridName: 'Project Pricing Service',
            pageName: 'Project Pricing Service',
        };

        mutateGridLayoutAsync({ data }).then(() => {
            refetchGridLayout();
        });
    };

    useEffect(() => {
        if (!gridLayouts?.data) return;

        try {
            const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

            const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

            // if (filterData && columnJson) {
            setGridConfig({
                columns: columnJson,
                dataState: filterData,
            });
            // }
        } catch (error) {
            console.log('Error parsing grid layout JSON:', error);
        }
    }, [gridLayouts?.data]);

    // ----------------------------------------------------------------------------------------

    const servicesEditableColumnsWithPermission: GridColumnConfig[] = [...servicesEditableColumns, ...customColumns];

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <>
            <Dialog
                open={openDialog}
                fullWidth={true}
                maxWidth={'xl'}
                // onClose={handleClose}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
            >
                <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClosedDialog}
                    sx={{
                        position: 'absolute',
                        right: 10,
                        top: 3,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Tooltip title={<Typography variant="body1">Close</Typography>}>
                        <CloseIcon />
                    </Tooltip>
                </IconButton>
                <DialogContent dividers style={styling.contentPadding} className="popupDilog">
                    <ReactHookForm formName="PROJECT_ADD_NEW_PRICING_FORM" onSubmit={handleSubmit} formContextProps={form}>
                        <Grid container spacing={1}>
                            <Grid item lg={12} sm={12} xl={12} xs={12}>
                                <AddNewPriceFields projectID={projectID} projectType={projectType} isEdit={isEdit} isLoading={isPricingLoading || isPricingFetching} setEnablePrice={handleEnableValidation} />
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12} xs={12}>
                                <Typography variant="body2"><b>SERVICES AND PRICING</b></Typography>
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12} xs={12}>
                                <ProjectServiceNotReadyFields />
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12} xs={12}>
                                <FormGridEditable
                                    fileTitle='project_service_pricing_list'
                                    dataItemKey="serviceID"
                                    columns={servicesEditableColumnsWithPermission}
                                    name="pricingServices"
                                    customGridCell={CustomGridCell}
                                    customGroupHeaderCell={CustomGroupHeaderCell}
                                    dataItems={filteredPlanLibraries || []}
                                    reorderable
                                    handleSearch={handleInputChange}
                                    handleSaveLayout={handleSaveLayout}
                                    isSaveLayout={true}
                                    gridConfigFromApi={gridConfig}
                                    handleResetLayout={handleResetLayout}
                                   // selectedField={'isSelected'}
                                    isBusy={isLoading || isFetching || isNewPriceLoading || isPricingLoading || isPricingFetching}
                                />
                            </Grid>
                        </Grid>
                    </ReactHookForm>
                </DialogContent>
                <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
                    <DialogActions className="spaceBetween">
                        <Button variant="outlined" style={{ width: '130px' }} onClick={onClosedDialog}>
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSubmitClick}
                            variant="contained"
                            style={{ width: '130px' }}
                            disabled={isLoading || isNewPriceLoading || isReadOnlyPermission}>
                            Save
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
            {checkedServiceDialog && (
                <Dialog
                    open={checkedServiceDialog}
                    className="modalpopup"
                    title={'CONFIRM STATUS'}
                // onClose={closeDialog}
                >
                    <div>
                        <div style={{ padding: '25px 50px', textAlign: 'center' }}>
                            <div>Do you want the Accrual Reinspection Price to match the Billing Reinspection Price?</div>
                            {/* <LoadingIndicator isLoading={isLoadingUnitComplete} /> */}
                        </div>
                    </div>
                    <DialogActionsBar>
                        {isReadOnlyPermission && (
                            <Button style={{ maxWidth: '140px' }} size='small' type="button" variant="outlined" onClick={handleClosedCheckoxDialog}>
                                Cancel
                            </Button>
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }} className="  ">
                            <button
                                className="btn btn-sm btn-primary btn-lightGrey"
                                style={{
                                    backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                                    color: isReadOnlyPermission ? 'black' : '#fff',
                                    cursor: 'pointer', padding: 2, marginRight: 6
                                }}
                                disabled={isReadOnlyPermission}
                                onClick={handleClosedCheckoxDialog}
                                autoFocus
                            >
                                No
                            </button>

                            <button
                                className="btn btn-sm btn-primary  btn-delete"
                                style={{
                                    backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                                    color: isReadOnlyPermission ? 'black' : '#fff',
                                    cursor: 'pointer', padding: 2
                                }}
                                type="button"
                                onClick={handleSumbitConfirm}
                                disabled={isLoading || isReadOnlyPermission}
                            >
                                Yes
                            </button>
                        </div>
                    </DialogActionsBar>
                </Dialog>
            )}
        </>
    );
}